/**
 * Enum number values.
 * @enum {number}
 */
export const Embedding = {
    DO_NOT_ALLOW: 0,
    ALL_WEBSITES: 1,
    MY_WEBSITES: 2,
};
